import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async setContractStatus(id, val, data = {}) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/contracts/${id}/status/`,
      method: HttpMethod.PUT
    };

    const payload = {
      status: val,
      ...data,
    };
    try {
      const res = await processRequest(ep, { data: payload });

      const item = processSuccessResponse(res);

      return { item };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createContract(data) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/contracts/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });

      const item = processSuccessResponse(res);

      return { item };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
